/* Verolae · Week by week — scroll-driven timeline.
   Port of the inline <script> of the source site "week_by_week" section:
   - phases get `in-viewport` once their top crosses the bottom of the window (never removed),
   - the vertical timeline line (::before) is painted with a gradient whose "active" percentage
     only ever grows (locked maximum progress),
   - on desktop (>= 768px) the phase closest to the viewport midpoint and every phase before it
     get `is-active` (locked, never reversed).
   Supports multiple instances (scoped per section root) and the Shopify theme editor. */
(function () {
  'use strict';

  var SELECTOR = '.wbw-section[data-wbw-section]';

  function cssId(id) {
    return '#' + (window.CSS && typeof window.CSS.escape === 'function' ? window.CSS.escape(id) : id);
  }

  function initWeekByWeek(sectionEl) {
    if (!sectionEl || sectionEl.getAttribute('data-wbw-init') === 'true') return;

    var timeline = sectionEl.querySelector('.wbw-timeline');
    var phases = Array.prototype.slice.call(sectionEl.querySelectorAll('.wbw-phase'));
    if (!phases.length || !timeline) return;

    sectionEl.setAttribute('data-wbw-init', 'true');

    /* ---- Colours from the section settings (data attributes) ---- */
    var colorInactive = sectionEl.getAttribute('data-color-inactive') || '#f4e8dd';
    var colorViewport = sectionEl.getAttribute('data-color-viewport') || '#daa544';

    /* State tracker to maintain maximum progress scrolled */
    var maxPct = 0;
    var maxActiveIndex = 0;

    var styleTagId = 'wbw-line-style-' + sectionEl.id;
    var lineSelector = cssId(sectionEl.id) + ' ' + cssId(timeline.id) + '::before';

    /* ---- Mark phases that enter viewport & lock them ---- */
    function updateViewportClasses() {
      phases.forEach(function (p) {
        var rect = p.getBoundingClientRect();
        /* Phase enters if its top crosses the bottom of the window */
        if (rect.top < window.innerHeight) {
          p.classList.add('in-viewport');
        }
      });
    }

    /* ---- Update timeline line permanent progress (desktop and mobile) ---- */
    function updateTimelineLineColor() {
      var tlRect = timeline.getBoundingClientRect();
      var tlHeight = tlRect.height;
      if (tlHeight === 0) return;

      /* fraction of timeline above the vertical midpoint of viewport */
      var scrolled = (window.innerHeight / 2 - tlRect.top) / tlHeight;
      scrolled = Math.max(0, Math.min(1, scrolled));

      var pct = Math.round(scrolled * 100);

      /* Lock progress so line colour never recedes on scroll up */
      if (pct > maxPct) {
        maxPct = pct;
      }

      /* Apply gradient using maxPct achieved */
      var styleTag = document.getElementById(styleTagId);
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = styleTagId;
        document.head.appendChild(styleTag);
      }
      styleTag.textContent =
        lineSelector + ' {'
        + 'background: linear-gradient(to bottom,'
        + colorViewport + ' 0%,'
        + colorViewport + ' ' + maxPct + '%,'
        + colorInactive + ' ' + maxPct + '%,'
        + colorInactive + ' 100%) !important;'
        + '}';
    }

    /* ---- Scroll-based activation ----
       desktop: is-active locking; mobile: only viewport classes + line colour */
    function onScroll() {
      updateViewportClasses();
      updateTimelineLineColor();

      if (window.innerWidth >= 768) {
        var mid = window.innerHeight / 2;
        var closest = maxActiveIndex;
        var closestDist = Infinity;

        phases.forEach(function (p, i) {
          var rect = p.getBoundingClientRect();
          var dist = Math.abs(rect.top + rect.height / 2 - mid);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });

        /* Only progress forward, never reverse */
        if (closest > maxActiveIndex) {
          maxActiveIndex = closest;
        }

        /* Lock active styles on all passed phases */
        phases.forEach(function (p, i) {
          if (i <= maxActiveIndex) {
            p.classList.add('is-active');
          }
        });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    /* Teardown for the theme editor (section re-rendered / removed) */
    sectionEl.wbwDestroy = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      var styleTag = document.getElementById(styleTagId);
      if (styleTag && styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
      sectionEl.removeAttribute('data-wbw-init');
    };
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initWeekByWeek);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify theme editor hooks */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target && event.target.querySelectorAll ? event.target : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), function (el) {
      if (typeof el.wbwDestroy === 'function') el.wbwDestroy();
    });
  });
})();
